export const REVIEW_AI_INSIGHTS = "REVIEW_AI_INSIGHTS";

const initialState = null; 

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case REVIEW_AI_INSIGHTS:
            return action.payload;
        default:
            return state;
    }
}

const storeName = "reviewAiInsights"

const storeMapping = {[storeName]: reducer};

export const reviewAiInsightsSelector = (state) => state[storeName];

export default storeMapping;
